// extracted by mini-css-extract-plugin
export var brand = "_1f-9";
export var button = "_1f-0";
export var chevron = "_1f-v";
export var chevronButton = "_1f-w";
export var content = "_1f-n";
export var danger = "_1f-g";
export var dangerOutlined = "_1f-h";
export var dark = "_1f-l";
export var darkTheme = "_1f-c";
export var extraSmall = "_1f-4";
export var fullWidth = "_1f-8";
export var ghost = "_1f-d";
export var gray = "_1f-t";
export var icon = "_1f-p";
export var iconButton = "_1f-s";
export var iconButtonBorder = "_1f-x";
export var iconButtonBorderDark = "_1f-y";
export var iconButtonBorderLight = "_1f-z";
export var iconLeft = "_1f-q";
export var iconRight = "_1f-r";
export var large = "_1f-1";
export var light = "_1f-m";
export var medium = "_1f-2";
export var micro = "_1f-5";
export var nano = "_1f-7";
export var outlined = "_1f-k";
export var pending = "_1f-a";
export var primary = "_1f-i";
export var shadow = "_1f-o";
export var small = "_1f-3";
export var solidLight = "_1f-e";
export var solidLightBrand = "_1f-f";
export var spinner = "_1f-u";
export var transparent = "_1f-j";
export var warning = "_1f-b";
export var wideNano = "_1f-6";